import EmptyCampaignTemplatesPage from "./EmptyCampaignTemplatesPage";

export default EmptyCampaignTemplatesPage;
